<template>
	<div class="container-list">
		<div class="common-page common-head">
			<div class="common-page common-head-title">
				<i class="icon-tr-other" style="padding-right: 5px"></i>
				编辑演练{{ markType }}
			</div>
		</div>
		<div class="ml20 mt20 f18 blue">
			<i class="el-icon-back cursor" @click="$router.back()"> 返回</i>
		</div>
		<!-- <unitList @select="getUnit" @getFirst='getOne'></unitList> -->
		<div class="flex center ml20">
			<el-form ref="form" :model="form" :rules="rules" class="mt20" style="width: 100%">
				<h2 class="center">社会单位灭火和应急疏散{{ markType }}</h2>

				<el-row :gutter="24" class="mt20">
					<el-col :span="24">
						<el-row>
							<div class="center" style="font-size: 20px; line-height: 50px">
								<div class="center" style="width: 70%">
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了保护火灾发生时人员的生命和财产安全，最大限度地减少人员伤亡和财产损失，根据《消防法》61号令的精神，按照《社会单位灭火和应急疏散预案编制及实施导则》（GB/T
									38315-2019）要求，特制定此灭火和应急疏散预案。
								</div>
							</div>
							<el-row class="center mt20">
								<el-col :span="16">
									<el-form-item prop="drill_name" label-width="100px" :label="`${markType}名称`">
										<!-- <el-input v-model="form.patrol.c_point_area"></el-input>
               -->
										<el-input v-model="form.drill_name"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</el-row>
						<el-row class="center" v-if="!($route.query.page == 3)">
							<el-col :span="16">
								<el-form-item label-width="100px" prop="drill_time" :label="`${markType}时间`">
									<!-- <el-input v-model="form.patrol.c_point_number" ></el-input> -->
									<el-date-picker v-model="form.drill_time" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row class="center">
							<el-col :span="16">
								<el-form-item label-width="100px" prop="drill_tower" :label="`${markType}区域`">
									<!-- <el-input v-model="form.drill_tower"></el-input> -->
									<el-select v-model="form.drill_tower" placeholder="请选择" filterable @change="changetower($event, true)">
										<el-option v-for="(item, index) in units" :key="item.dueng" :label="item.dueng" :value="item.dueng" v-show="index > 0">{{ item.dueng }}</el-option>
									</el-select>

									<el-select v-model="form.drill_tier" placeholder="请选择" filterable @change="changetier($event, 1)">
										<el-option v-for="(item, index) in select2" :key="item" :label="item" :value="item" v-show="index > 0"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row class="center mt20" v-if="$route.query.page == 0">
							<el-col :span="16">
								<el-form-item prop="plan_choose_uuid" label-width="100px" :label="`预案选择`">
									<!-- <el-input v-model="form.patrol.c_point_area"></el-input>
               -->
									<el-select @change="changeDrill" v-model="form.plan_choose_uuid" placeholder="请选择" filterable>
										<el-option v-for="item in drillList" :key="item.uuid" :label="item.name" :value="item.uuid">{{ item.name }}</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-row class="center">
								<el-col :span="16" class="mt20">
									<h2>一、单位的基本情况</h2>
								</el-col>
							</el-row>
							<el-row class="center mt20">
								<el-col :span="16">
									<el-form-item prop="base_jibenqk" label="（1）单位基本情况">
										<el-input v-model="form.base_jibenqk" type="textarea" placeholder="主要包括：单位名称、地址、使用功能、建筑面积、建筑结构及主要人员等情况" :rows="6"></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row class="center mt20">
								<el-col :span="16">
									<el-form-item prop="xiaofang_zhongdian" label="（2）消防安全重点部位">
										<el-input
											v-model="form.xiaofang_zhongdian"
											type="textarea"
											placeholder="消防控制室、消防水泵房、变配电室、厨房、空调机房、发电机房、可燃物品仓库、集体宿舍等部位"
											:rows="6"
										></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row class="center mt20">
								<el-col :span="16">
									<el-form-item prop="xiaofang_sheshi" label="（3）消防设施、灭火器材情况">
										<el-input
											v-model="form.xiaofang_sheshi"
											type="textarea"
											placeholder="火灾自动报警、自动喷水灭火、防排烟、气体灭火、室内、外消火栓、灭火器等"
											:rows="6"
										></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row class="center mt20">
								<el-col :span="16">
									<el-form-item prop="xiaofang_peibei" label="（4）消防组织、志愿消防队人员及装备配备情况">
										<el-input v-model="form.xiaofang_peibei" type="textarea" placeholder="消防管理归口部门、志愿消防队人员情况、微型消防站器材配备情况" :rows="6"></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row class="center">
								<el-col :span="12" class="mt20">
									<h2>二、各应急组织机构人员设置情况及主要职责</h2>
								</el-col>
								<!-- 职责区域选择 -->
								<el-col :span="2">
									<el-select v-model="selectPerson.tower" placeholder="请选择" filterable @change="changeSelecttower($event, true, true)">
										<el-option v-for="(item, index) in units" :key="item.dueng" :label="item.dueng" :value="item.dueng"></el-option>
									</el-select>
								</el-col>
								<el-col :span="2">
									<el-select v-model="selectPerson.tier" placeholder="请选择" filterable @change="changeSelecttier($event, 1)">
										<el-option v-for="item in perselect2" :key="item" :label="item" :value="item"></el-option>
									</el-select>
								</el-col>
								<el-col :span="2">
									<el-button class="ml10" @click="resetSet" type="primary">重置</el-button>
								</el-col>
							</el-row>

							<el-row class="center mt20">
								<el-col :span="16">
									<el-form-item label-width="100px" label="参加人员">
										<el-row class="flex">
											<el-col :span="10">
												<ul>
													<!-- 参加人员按钮组 -->
													<li v-for="(item, index) in groupList" :key="index">
														<el-button
															class="ml10 mt10 perbutton"
															:type="form.person[$map.planGroup[item.zuzhi_xuhao]] ? (form.person[$map.planGroup[item.zuzhi_xuhao]].length > 0 ? 'primary' : 'info') : 'info'"
															size="small"
															plain
															@click="selectgroup(item, index)"
															>{{ item.zuzhi_name }}
														</el-button>
													</li>
												</ul>
											</el-col>
											<div class="ml20 mt20" style="min-width:800px">
												<!-- 职责穿梭框 -->
												<transfer
													filterable
													:filter-method="filterMethod"
													:titles="['人员库', groupName || '请选择']"
													filter-placeholder="请输入单位名"
													v-model="selectedPeople"
													:data="compOption"
													@change="handlechange"
												>
												</transfer>
											</div>
										</el-row>
									</el-form-item>
								</el-col>
							</el-row>
							<!-- 职责文本 -->
							<el-row class="center">
								<el-col :span="16">
									<el-form-item label="各组职责">
										<div class="duty mt10">
											<p>
												（1）火场指挥组：由消防安全管理人负责总指挥，消防安全归口管理部门负责人协助。火场指挥组主要负责根据方便现场指挥、通信联络、保证自身安全的原则，指挥协调各职能小组和遗物消防队开展工作，根据火情决定是否通知人员疏散并组织实施，及时控制和扑救火灾。公安消防队到达后，及时向指挥员报告火场内的有关情况，按照指挥员的统一部署，协调配合公安消防队开展灭火救援行动。
											</p>

											<p>
												（2）通信联络组：由现场工作人员及消防控制室值班人员组成，负责操作消防自动控制系统，并与指挥机构和当地消防部门、区域联防单位及其他应急行动涉及人员的通信、联络；
											</p>
											<p>
												（3）灭火行动组：由自动消防系统操作员、专兼职消防员组成，负责在发生火灾后立即利用消防设施、器材扑救初起火灾；
											</p>
											<p>
												（4）疏散引导组：由指定的一线岗位人员和专兼职消防员组成，负责引导人员正确疏散、逃生，清点人员并逐级上报；
											</p>

											<p>
												（5）防护救护组：由指定的具有基础医护知识的人员组成，负责抢救、护送受伤人员；
											</p>

											<p>
												（6）安全保卫组：由单位安保人员组成，负责阻止与场所无关人员进入现场，保障消防疏散通道和消防车通道畅通，消防扑救场地无障碍物，保护火灾现场，协助消防部门开展火灾调查；
											</p>
											<p>
												（7）后勤保障组：由相关物资保管人员组成，负责抢险物资、器材器具的供应及后勤保障。
											</p>
											<p>
												（8）机动组：受火场指挥组的指挥，负责增援行动和其他临时任务。
											</p>
										</div>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row class="center">
								<el-col :span="16" class="mt20">
									<h2>三、火灾情况记录</h2>
								</el-col>
							</el-row>
							<el-row class="center mt20">
								<el-col :span="16">
									<el-form-item prop="fire_time  " label="（1）起火时间段：">
										<el-input v-model="form.fire_time" type="textarea" :rows="3"></el-input>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row class="center mt20">
								<el-col :span="16">
									<el-form-item prop="fire_location" label="（2）起火位置：">
										<el-input v-model="form.fire_location" type="textarea" :rows="3"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row class="center mt20">
								<el-col :span="16">
									<el-form-item prop="fire_thing  " label="（3）起火物品：">
										<el-input v-model="form.fire_thing" type="textarea" :rows="3"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row class="center mt20">
								<el-col :span="16">
									<el-form-item prop="qihuo_fangxiang " label="（4）燃烧范围及火势蔓延情况">
										<el-input v-model="form.qihuo_fangxiang" type="textarea" :rows="3"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row class="center mt20">
								<el-col :span="16">
									<el-form-item prop="zhuyhao_qihuo" label="（5）消防安全重点部位：">
										<el-input v-model="form.zhuyhao_qihuo" type="textarea" :rows="3"></el-input>
									</el-form-item>
								</el-col> </el-row
							><el-row class="center mt20">
								<el-col :span="16">
									<el-form-item prop="weihai_houguo" label="（6）火灾造成的危害和影响：">
										<el-input v-model="form.weihai_houguo" type="textarea" :rows="3"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row class="center">
								<el-col :span="16" class="mt20">
									<h2>四、报警、接警处置程序</h2>
								</el-col>
							</el-row>
							<el-row class="center">
								<el-col :span="16">
									<el-form-item>
										<div class="duty mt10">
											<p>
												（1）无论任何部门或人员发现火灾，应立即向公司消防控制室（单位内部报警电话：<span style="display: inline-block; width: 140px"
													><el-input size="small" v-model="form.neibu_phone">2</el-input></span
												>
												；消控室值班电话：<span style="display: inline-block; width: 140px"><el-input size="small" v-model="form.xiaokong_phone">2</el-input></span
												>及“119”公安消防队报警。同时，立即将火情报告给本单位领导和值班领导。
											</p>

											<p>（2）拨打“119”报火警时要沉着冷静，应讲清以下内容：</p>
											<p class="ml10">
												1）着火单位； 2）着火部位； 3）着火物质； 4）有无人员被困； 5）单位具体位置； 6）报警电话号码； 7）报警人姓名。
											</p>
											<p>
												（3）单位领导接警后，启动应急预案，按预案确定内部报警方式和疏散范围，组织指挥初期火灾的扑救和人员疏散工作，安排力量做好警戒工作。
											</p>
											<p>
												（4）消防控制室接到报警后，应立即按照以下程序处置：
											</p>

											<p>
												（1）接到报警（或收到自动报警信号），值守人员通过视频监控并通知巡查人员、报警区域的楼层值班、工作人员迅速赶到起火点证实，现场人员确认火灾后要及时报告消防控制室。
											</p>

											<p>
												2）接到确切的报警电话，要立即启动固定消防系统，如自动喷淋、防排烟风机、防火卷帘等；切断非消防电源；开启事故广播系统，依照烟、火蔓延扩散威胁严重程度，区分不同区域层次顺序，逐区域的通知，并沉着、镇静地指明疏散路线和方向。
											</p>
											<p>
												3）再次拨打“119”电话向公安机关报告火警，并及时通知本单位消防应急指挥部领导。
											</p>
											<p>
												4）指派专人到公司附近的主要道口，迎接并引导消防车快捷到达火灾现场。
											</p>
											<p>5）完成消防应急指挥部交办的其他工作。</p>
										</div>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row class="center">
								<el-col :span="16" class="mt20">
									<h2>五、初期火灾处置程序和措施</h2>
								</el-col>
							</el-row>

							<el-row class="center">
								<el-col :span="16" class="mt20">
									<p>
										（1）指挥部、各行动小组和义务消防队迅速集结，按照职责分工，进入相应位置开展灭火救援行动。
									</p>
									<p class="mt20">
										（2）发现火灾时，起火部位现场员工应当与1min内形成灭火第一战斗力量，在第一时间内采取如下措施：灭火器材、起火部位现场员工利用现场灭火器、消防栓等器材、设施灭火；电话或火灾报警按钮附近的员工打“119”电话报警、报告消防控制室或单位值班人员；安全出口或通道附近的员工负责引导人员进行疏散。若火势扩大，单位应当于3min内形成第二战斗力量，及时采取如下措施：通信联络组按照应急预案要求通知预案设计的员工赶赴火场，向火场指挥员报告火灾情况，将火场指挥员的指令下达给有关员工；灭火行动组根据火灾情况利用本单位的消防器材、设施扑救火灾；疏散引导组按分工组织引导现场人员进行疏散；安全救护组负责协助抢救、护送受伤人员；现场警戒组组织无关人员进行入火场，维持火场秩序。
									</p>
									<p class="mt20">
										（3）相关部位人员负责关闭空调系统和煤气总阀门，及时疏散易燃易爆化学危险品及其他重要物品
									</p>
								</el-col>
							</el-row>

							<el-row class="center">
								<el-col :span="16" class="mt20">
									<h2>六、应急疏散的组织程序和措施</h2>
								</el-col>
							</el-row>
							<el-row class="center">
								<el-col :span="16">
									<p class="mt20">
										（1）火场指挥部根据火灾的发展情况，决定发出疏散通报，消防控制室利用广播系统对外发布疏散引导通知。疏散的通知根据火灾部位的相关楼层或相关防火分区进行播放，并根据现场火情确定是否疏散其它部位的人员。播放顺序按：着火楼层（防火分区）和相连楼层（相关防火分区）；着火层以上各层由下自上逐层疏散；着火层以下各层由上自下逐层疏散。
									</p>
									<p class="mt20">
										（2）疏散引导组应首先疏散被火势围困的顾客，然后再疏散火场周围的物资。疏散出的物资要放在不影响消防通道和远离火场的安全地点。疏散引导组应注意自己的安全，提前做好必要的防护。
									</p>
									<p class="mt20">
										（3）引导人员疏散时要不断用手势和喊话的方式引导稳定被困人员的情绪，维护秩序。
									</p>
									<p class="mt20">
										（4）引导人员疏散应利用防烟楼梯，封闭楼梯和室外楼梯，也可利用未被烟火侵袭的普通楼梯，或其他能够达到安全地带的途径，将人流按照快捷合理的疏散路线引导到场外。疏散引导组人员应逐层（逐个房间）检查，以防疏漏人员。
									</p>
									<p class="mt20">
										（5）消防队到达火场后，应听从公安消防人员的指挥进行疏散工作。
									</p>
								</el-col>
							</el-row>

							<el-row class="center">
								<el-col :span="16" class="mt20">
									<h2>七、安全防护救护和通信联络的程序及措施</h2>
								</el-col>
							</el-row>

							<el-row class="center">
								<el-col :span="16">
									<p class="mt20">
										（1）建筑外围安全防护。清楚路障，疏导车辆和围观群众，确保消防车通道畅通；维护现场秩序，严防趁火打劫；引导消防车，协助消防车取水、灭火。
									</p>
									<p class="mt20">
										（2）建筑首层出入口安全防护。禁止无关人员进入起火建筑；对火场中疏散的物品进行规整并严加看管；指引公安消防人员进入起火部位。
									</p>
									<p class="mt20">
										（3）起火部位的安全防护。引导、疏散秩序；组织无关人员进入起火部位；防护好现场的消防器材、装备
									</p>
									<p class="mt20">
										（4）在安全区及时对手上人员进行救治，将危重病人及时送往医院救治。
									</p>
									<p class="mt20">
										（5）利用电话、对讲机等建立有线、无线通信网路，确保火场信息传递畅通。
									</p>
									<p class="mt20">
										（6）火场指挥部、各行动组、各消防安全重点部位必须确定专人负责信息传递，保证火场指令得到及时传递、落实。
									</p>
									<p class="mt20">（7）安排专人在主要路口接应消防车。</p>
								</el-col>
							</el-row>
							<el-row class="center">
								<el-col :span="16" class="mt20">
									<h2>八、绘制灭火和应急疏散计划图</h2>
								</el-col>
							</el-row>

							<el-row class="center">
								<el-col :span="16">
									<el-form-item label-width="100px" prop="miehuo_image" label="上传图片">
										<el-col>
											<el-upload action="#" :http-request="up1" list-type="picture-card" :file-list="fileList1" :limit="10">
												<i slot="default" class="el-icon-plus"></i>
												<div slot="file" slot-scope="{ file }">
													<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
													<span class="el-upload-list__item-actions">
														<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
															<i class="el-icon-zoom-in"></i>
														</span>

														<span class="el-upload-list__item-delete" @click="handleRemove(file, 'nowImage1')">
															<i class="el-icon-delete"></i>
														</span>
													</span>
												</div>
											</el-upload>
										</el-col>
									</el-form-item>
								</el-col>
							</el-row>
							<!-- <el-row class="center">
                <el-col :span="16">
                  <el-form-item
                    label-width="100px"
                    prop="drill_image"
                    label="上传图片"
                    v-if="
                      ($route.query.id && (editable || form.drill_zongjie)) ||
                      $route.query.page == 1
                    "
                  >
                    <el-col>
                      <el-upload
                        action="#"
                        :http-request="upload"
                        list-type="picture-card"
                        :file-list="fileList"
                        :limit="10"
                      >
                        <i slot="default" class="el-icon-plus"></i>
                        <div slot="file" slot-scope="{ file }">
                          <img
                            class="el-upload-list__item-thumbnail"
                            :src="file.url"
                            alt=""
                          />
                          <span class="el-upload-list__item-actions">
                            <span
                              class="el-upload-list__item-preview"
                              @click="handlePictureCardPreview(file)"
                            >
                              <i class="el-icon-zoom-in"></i>
                            </span>

                            <span
                              class="el-upload-list__item-delete"
                              @click="handleRemove(file, 'nowImage')"
                            >
                              <i class="el-icon-delete"></i>
                            </span>
                          </span>
                        </div>
                      </el-upload>
                    </el-col>
                  </el-form-item>
                </el-col>
              </el-row> -->
						</el-row>

						<el-row class="center">
							<el-col :span="16" class="mt20">
								<h2>九、注意事项</h2>
							</el-col>
						</el-row>
						<el-row class="center">
							<el-col :span="16">
								<p class="mt20">
									（1）建筑外围安全防护。清楚路障，疏导车辆和围观群众，确保消防车通道畅通；维护现场秩序，严防趁火打劫；引导消防车，协助消防车取水、灭火。
								</p>
								<p class="mt20">
									（2）灭火疏散场地设置要安全，应能进能退、攻防兼备。
								</p>
								<p class="mt20">
									（3）指挥员要密切注意火场上各种复杂情况和险情的变化，适时采取果断措施，避免伤亡。
								</p>
								<p class="mt20">
									（4）灭火救援应急行动结束后，要做好现场清理工作。
								</p>
								<p class="mt20">
									（5）对演练过程进行拍照、摄录，妥善保存演练相关文字、图片、录像等资料。
								</p>
								<p class="mt20">（6）其他需要特别警示的事项。</p>
							</el-col>
						</el-row>
					</el-col>
					<!-- <el-col :span="12">
          <el-row>
            <el-form-item label-width="160px" prop="" label="巡查频次设置 ">
              <el-switch v-model="form.isTime"> </el-switch>
              &nbsp;
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-plus"
                @click="addtime"
              ></el-button>
            </el-form-item>
          </el-row>
          <div
            v-show="form.isTime"
            v-for="(item, index) in form.get_rate"
            :key="index"
          > -->
					<!-- <el-row>
              <el-form-item label-width="160px" prop="" label="巡查时间 ">
                <el-col :span="6">
                  <el-time-picker
                    v-model="item.m_start_time"
                    type="time"
                    value-format="HH:mm:ss"
                    placeholder="开始日期"
                  >
                  </el-time-picker>
                </el-col>
                <el-col :span="6" class="ml20">
                  <el-time-picker
                    v-model="item.m_end_time"
                    type="time"
                    value-format="HH:mm:ss"
                    placeholder="结束日期"
                  >
                  </el-time-picker>
                </el-col>
              </el-form-item>
            </el-row> -->
					<!-- <el-row>
              <el-form-item label-width="160px" prop="" label="巡查时间 ">
                <el-col :span="6">
                  <el-select v-model="item.m_rate">
                    <el-option :value="1">1</el-option>
                    <el-option :value="2">2</el-option>
                    <el-option :value="3">3</el-option>
                    <el-option :value="4">4</el-option>
                    <el-option :value="5">5</el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-row> -->
					<!-- </div>
        </el-col> -->
				</el-row>
			</el-form>
		</div>

		<el-dialog :visible.sync="dialogVisible" width="60%">
			<img width="100%" :src="dialogImageUrl" alt="" />
		</el-dialog>
		<!-- <div class="btn-box center" v-if="this.$route.query.type==0">
          
       <el-button type="success" class="ml20" @click="downLoad()">导出</el-button>
      <el-button type="primary" @click="$router.back()" class="ml20">返回</el-button>

      </div> -->
		<div class="btn-box center">
			<el-button type="primary" @click="onSubmit" :loading="btnLoading" class="ml20" v-hasPermi="['plan:drillrecord:addAndUpdate']">保存</el-button>
			<el-button type="success" class="ml20" v-if="this.$route.query.id" @click="downLoad()">导出</el-button>
			<!-- <el-button type="primary" class="ml20" @click="onSubmit(1)" v-hasPermi="['plan:record:syncWordWordRecord']" v-if="$route.query.page == 3 && $route.query.id" :loading="btnLoading"
				>保存并同步</el-button
			> -->
			<el-button type="primary" @click="$router.back()" class="ml20">返回</el-button>
		</div>
		<el-backtop target=".common-body-style"></el-backtop>
	</div>
</template>

<script>
	// import {buildList} from './options'
	// import {addCompany, editCompany} from "../../api/company";
	// import {getArea} from "../../api/common";
	import { getSafeList } from "../../api/safety";
	import OSS from "ali-oss";
	import transfer from "../../components/transfer";
	export default {
		components: { transfer },
		inject: ["reload"],
		data() {
			return {
				id: this.$route.query.id || "",
				c_num: this.$route.query.c_num || this.$store.state.user.company.cCompanyNum,
				editable: this.$route.query.type == 1 || this.$route.query.type == 3,
				groupName: "",
				markType: this.$route.query.page == 3 ? "预案" : "演练",
				peopleAll: false,
				groupList: [], // 所有组别
				peopleList: [], // 所有人员
				selectPeopleList: [], // 带选择的人员
				selectedPeople: [], // 已选择的人员
				selectAllPeople: [], //已选择
				filterMethod(query, item) {
					return item.label.indexOf(query) > -1;
				},
				compOption: [], // 人员库
				renyuancopy: [],
				selectGroup: null,
				btnLoading: false,
				selectIndex: null,
				units: [],
				drillList: [], // 预案
				select2: [],
				perselect2: [],
				nowImage: [],
				nowImage1: [],
				dialogVisible: false,
				dialogImageUrl: "", // 预览图片url
				personParmms: {
					tower: "",
					tier: "",
					company_num: "",
				},
				// nameObj:{},
				form: {
					drill_tower: "",
					drill_tier: "",
					drill_name: "",
					drill_time: "",
					drill_summary: "",
					drill_status: Number(this.$route.query.page),
					drill_zongjie: "",
					drill_uuid: "",
					plan_choose_uuid: "",
					drill_image: "",
					phone_danwei: "",
					phone_zhiban: "",
					person: {},
					base_jibenqk: "", //单位的基本情况
					xiaofang_zhongdian: "", // 消防安全重点部位
					xiaofang_peibei: "", //消防组织、志愿消防队人员及装备配备情况
					fire_time: "", // 起火时间段
					fire_location: "", // 起火位置
					fire_thing: "", //起火物
					zhuyhao_qihuo: "", //部位
					weihai_houguo: "", //影响
					qihuo_fangxiang: "", //范围
					neibu_phone: "", //  单位内部报警电话
					xiaokong_phone: "", //   消控室值班电话
					miehuo_image: "", // 灭火和应急疏散
					miehuo_neirong: "", // 灭火内容
					xiaofang_sheshi: "", //消防设施、灭火器材情况
				},
				selectPerson: {
					tower: "",
					tier: "",
				},
				rules: {
					plan_choose_uuid: [{ required: true, message: "请选择预案", trigger: "blur" }],
					drill_tower: [{ required: true, message: "请选择预案", trigger: "blur" }],
					drill_time: [{ required: true, message: "请选择预案", trigger: "blur" }],
					drill_name: [{ required: true, message: "请选择预案", trigger: "blur" }],
				},
				fileList: [],
				fileList1: [],
			};
		},
		computed: {},
		async created() {
			await this.getPersonAll();
			await this.$post("drill/grouplist", { c_company_num: this.c_num }).then((res) => {
				this.groupList = res.data;
				this.groupList.map((item) => {
					item.selectAll = false;
				});
			});

			await this.$post("/drill/towetinfo", { c_company_num: this.c_num }).then((res) => {
				this.units = res.data.list;
				this.units.unshift({ dueng: "全部", ceng: ["全部"] });
				this.units.map((item) => {
					if (item.dueng !== "全部" && item.ceng) {
						item.ceng.unshift("全部");
					}
				});
				if (!this.$route.query.id) {
					this.getPeople(1, 0);
				}

				// this.units.unshift({dueng:'无',ceng:''})
			});
			if (this.$route.query.id) {
				this.$post(`/drill/drillProgramInfo`, { drill_uuid: this.$route.query.id }).then((res) => {
					res.data.drill_summary = 1;
					this.nowImage1 = res.data.drill_image ? res.data.drill_image.split(",") : [];
					this.nowImage = res.data.miehuo_image ? res.data.miehuo_image.split(",") : [];

					this.nowImage.map((item, index) => {
						this.fileList.push({ name: "图片" + index, url: item });
					});
					this.nowImage1.map((item, index) => {
						this.fileList1.push({ name: "图片" + index, url: item });
					});
					this.$set(this, "form", res.data);
					this.changetower(this.form.drill_tower);
					this.changetower(this.form.drill_tower, null, true);

					// this.handleSelectPerson
					setTimeout(() => {
						console.log(this.form.person);
						for (var i in this.form.person) {
							console.log(this.form.person[i]);
							this.form.person[i].map((item) => {
								this.compOption.map((it) => {
									if (it.key == item) {
										it.direction = "right";
										it.disabled = true;
									}
								});
							});
						}
						this.getdrillList();

						// this.changetier();
						this.selectPerson.tower = this.form.drill_tower;
						this.selectPerson.tier = this.form.drill_tier;
					}, 1);
					// this.changetier()
					// for (var i in this.form.person) {
					//   if (this.form.person[i].length) {
					//        var arr = []
					//         this.form.person[i].map(it=>{
					//               arr.push(it.uuid)
					//         })
					//         this.form.person[i] = arr
					//   }
					// }

					// this.groupList.map((item, index) => {
					//   console.log(item);
					//   if (
					//     this.form.person[this.$map.planGroup[item.zuzhi_xuhao]].length
					//   ) {
					//     item.selectAll = true;
					//     this.groupList.splice(index, item);
					//   }
					// });
					console.log(this.form);

					this.itemchange("", true);

					// this.handleSelectPerson({tower:this.form.drill_tower,tier:this.form.drill_tier })

					// this.changeDrill()

					// if (!this.editable) {
					//   setTimeout(() => {
					//     var divs = document.getElementsByClassName(
					//       "el-upload--picture-card"
					//     );
					//     if (divs && divs.length) {
					//       divs[1].style.display = "none";
					//       divs[1].style.visibility = "hidden";
					//     }
					//   }, 100);
					// }
					this.getPeople(1, 0);
				});
			}
		},
		mounted() {},

		methods: {
			// 下方人员选择
			resetSet() {
				this.selectPerson.tower = "";
				this.selectPerson.tier = "";
				this.handleSelectPerson({
					tier: this.selectPerson.tier || this.form.drill_tier,
					tower: this.selectPerson.tower || this.form.drill_tower,
				});
			},
			changeSelecttower(val, e, select) {
				this.selectPerson.tier = "";
				this.changetower(val, false, select);
				this.handleSelectPerson({ tower: this.selectPerson.tower, tier: "" });
			},

			changeSelecttier() {
				this.handleSelectPerson({
					tower: this.selectPerson.tower,
					tier: this.selectPerson.tier,
				});
			},
			// 搜索列表
			handleSelectPerson({ tower, tier }) {
				var type = null; // 1：只有tower 2：有tower和tier 3：其他
				if ((tower && !tier) || (tower && tower !== "全部" && tier == "全部")) type = 1;
				if (tower && tower !== "全部" && tier && tier !== "全部") type = 2;
				if (!tower && !tier) type = 3;
				if (tower == "全部") type = 4;

				this.compOption.map((it) => {
					// console.log(it);
					// console.log(type);

					if (type == 1) {
						if (it.tower === tower && it.direction === "left") {
							it.disabled = false;
						} else {
							it.disabled = true;
						}
					} else if (type == 2) {
						if (it.tower === tower && it.tier === tier && it.direction === "left") {
							it.disabled = false;
						} else {
							it.disabled = true;
						}
					} else if (type == 4 && it.direction === "left") {
						this.selectPerson.tier = "全部";
						it.disabled = false;
					} else {
						it.disabled = true;
					}
					if (it.direction === "right") {
						it.disabled = true;
					}
					// 如果非固定职责
					if (it.organi && it.direction === "left") {
						it.disabled = false;
					}
					setTimeout(() => {
						// console.log(this.organi, 1);
						// console.log("🚀 ~ file: plan-add.vue:823 ~ this.compOption.map ~ it.organi:", it.organi, it.direction);
					}, 100);
				});
			},

			getPersonAll() {
				this.personParmms.company_num = this.c_num;

				//  this.personParmms.tower = this.form.drill_tower
				// this.personParmms.tier =this.form.drill_tier
				console.log(this.personParmms);
				this.$post("/drill/filterByPartition", this.personParmms).then((res) => {
					this.selectPeopleList = res.data;
					var arr = [];
					this.selectPeopleList.map((item) => {
						var obj = {
							label: item.name + `(${item.tower + item.tier})`,
							key: item.uuid,
							disabled: false,
							direction: "left",
							tower: item.tower,
							tier: item.tier,
							organi: item.organi,
						};
						arr.push(obj);
					});
					this.compOption = arr;
					this.$post("/drill/filterByFixed", this.personParmms).then((res) => {
						console.log(res);
						// this.form.person = res.data
						var arr = [];
						var person = {};
						for (var i in res.data) {
							person[i] = [];
							res.data[i].map((item) => {
								// 如过是详情的话 去左侧 可选择
								if (this.$route.query.id) {
									var obj = {
										label: item.name + "(固定职责)",
										key: item.uuid,
										disabled: false,
										direction: "left",
										tower: "",
										tier: "",
									};
								} else {
									var obj = {
										label: item.name + "(固定职责)",
										key: item.uuid,
										disabled: true,
										direction: "right",
										tower: "",
										tier: "",
										organi: item.organi,
									};
								}
								arr.push(obj);
								person[i].push(item.uuid);
							});
						}
						console.log(person + "get person ");
						this.compOption = this.compOption.concat(arr);
						this.renyuancopy = this.compOption.concat(arr);
						if (!this.$route.query.id) {
							this.form.person = person;
							this.handleSelectPerson({
								tower: this.form.drill_tower,
								tier: this.form.drill_tier,
							});
						} else {
							// alert(333);
						}

						setTimeout(() => {
							// console.log(this.compOption);
						}, 3000);
					});
				});
			},
			handleAll(val) {
				this.groupList.map((item, index) => {
					item.selectAll = val;
					this.personAll(val, item, index);
				});
			},
			up1(val) {
				this.upload(val, 1);

				return;
			},
			changetower(val, istr, select) {
				this.selectPerson.tower = val;
				if (!select) {
					this.handleSelectPerson({
						tower: this.form.drill_tower,
						tier: this.form.drill_tier,
					});
				}
				if (istr) {
					this.form.drill_tier = "";
				}
				this.units.map((item, index) => {
					if (item.dueng === val) {
						select ? (this.perselect2 = item.ceng) : (this.select2 = item.ceng);
					}
				});
				//  this.getPersonAll()
			},
			changetier(val, clear) {
				// this.getPersonAll()
				this.selectPerson.tower = this.form.drill_tower;
				this.selectPerson.tier = val;
				if (!(this.$route.query.page == 3)) {
					if (clear) {
						this.clearForm();
					}
					this.getdrillList();
				}
				this.handleSelectPerson({
					tower: this.form.drill_tower,
					tier: this.form.drill_tier,
				});
			},
			clearForm() {
				var obj = { ...this.form };
				Object.keys(this.form).forEach((key) => (this.form[key] = ""));
				this.form.drill_tier = obj.drill_tier || "";
				this.form.drill_tower = obj.drill_tower || "";
				this.form.drill_uuid = obj.drill_uuid || "";
				this.form.drill_time = obj.drill_time || "";
				this.form.drill_name = obj.drill_name || "";
				this.form.person = obj.person || {};
				this.fileList1 = [];
				this.nowImage = [];
				this.nowImage1 = [];
			},
			downLoad() {
				// var url = 'http://192.168.0.108:8881'
				// var url = "https://tr.tongren119.com";
				window.open(`${this.$config.apiUrl}/drill/exportWord?uuid=${this.$route.query.id}`);
			},
			getdrillList() {
				var tower = this.form.drill_tower;
				// 查询预案
				var tier = this.form.drill_tier;
				var thing = 2;
				console.log(this.form);
				if (tower && tier && thing !== undefined) {
					this.$post("/drill/selectPlan", {
						tower,
						tier,
						thing,
						companyNum: this.c_num || this.$store.state.user.company.cCompanyNum,
					}).then((res) => {
						this.drillList = res.data;
					});
				}
			},
			changeDrill() {
				var uuid = this.form.drill_uuid;
				this.compOption.map((item) => {
					(item.direction = "left"), (item.disabled = false);
				});
				//  /drill/drillinfo
				this.$post("/drill/drillinfoRehearsal", {
					drill_uuid: this.form.plan_choose_uuid,
				}).then((res) => {
					var obj = {
						drill_time: this.form.drill_time,
						drill_name: this.form.drill_name,
					};

					this.form = { ...res.data, ...obj };
					this.form.drill_uuid = uuid;

					this.nowImage1 = res.data.drill_image ? res.data.drill_image.split(",") : [];
					this.nowImage = res.data.miehuo_image ? res.data.miehuo_image.split(",") : [];
					//      this.nowImage.map((item, index) => {
					//   this.fileList.push({ name: "图片" + index, url: item });
					// });
					this.nowImage1.map((item, index) => {
						this.fileList1.push({ name: "图片" + index, url: item });
					});
					// console.log(this.form);
					this.selectPerson.tower = this.form.drill_tower;
					this.selectPerson.tier = this.form.drill_tier;
					// this.handleSelectPerson
					this.handleSelectPerson({
						tower: this.form.drill_tower,
						tier: this.form.drill_tier,
					});
					for (var i in this.form.person) {
						if (this.form.person[i].length) {
							this.form.person[i].map((item) => {
								this.compOption.map((it) => {
									if (item === it.key) {
										it.direction = "right";
										it.disabled = true;
									}
								});
							});
						}
					}
					this.getPeople(1, 0);
					// var {person} = res.data
					//  var obj = {
					//   1:person.zhihuiName,
					//   2:person.lianluoName,
					//   3:person.miehuoName,
					//   4:person.shusanName,
					//   5:person.jiuhuName,
					//   6:person.jingjieName,
					//   7:person.baozhangName,
					//   8:person.jidongName
					// }
					// this.nameObj = obj
				});
			},
			getPeople(val, index) {
				if (val) {
					this.selectIndex = index;
					this.selectGroup = this.$map.planGroup[val];
					this.groupName = this.groupList[index].zuzhi_name;
				}

				// this.selectPeopleList = this.peopleList.quanbu[this.selectGroup];
				this.selectedPeople = [...this.selectAllPeople, ...this.form.person[this.selectGroup]];

				console.log(this.selectedPeople);
				console.log(this.compOption);
			},
			handlechange(value, direction, movedKeys) {
				console.log(this.selectIndex);
				console.log(this.selectGroup);
				console.log(this.groupName);
				// if(!(this.selectIndex) || !(this.selectGroup) || !(this.groupName)){
				//       alert(1)
				//       return

				// }
				console.log(direction);
				console.log(movedKeys);
				this.compOption.map((it, index) => {
					movedKeys.map((item) => {
						if (it.key === item) {
							// it.disabled = direction ==='right' ? true : false
							it.direction = direction;
						}
					});
				});
				this.handleSelectPerson({
					tier: this.selectPerson.tier || this.form.drill_tier,
					tower: this.selectPerson.tower || this.form.drill_tower,
				});

				this.itemchange("", null);

				return;
			},
			// 单个人员选择
			itemchange(val, load) {
				if (!load) {
					console.log(this.form.person[this.selectGroup]);
					console.log(this.selectedPeople);
					console.log(this.form.person[this.selectGroup]);
					this.form.person[this.selectGroup] = this.selectedPeople;
				} else {
					this.selectedPeople = this.form.person[this.selectGroup];
				}

				var item = null;
				item = this.groupList[this.selectIndex];
				// if (
				//   this.form.person[this.selectGroup].length &&
				//   this.form.person[this.selectGroup].length >=
				//     this.selectPeopleList.length
				// ) {
				//   item.selectAll = true;
				// } else {
				//   item.selectAll = false;
				// }
				this.groupList.splice(this.selectIndex, item);
			},
			// 整组选择
			personAll(val, it, index) {
				this.getPeople(it.zuzhi_xuhao, index);

				this.groupList.splice(index, it);
				this.selectAllGroup(val);
			},
			selectAllGroup(val) {
				var arr = [];
				if (val) {
					this.compOption.map((item) => {
						console.log(this.compOption);
						if (item.disabled == false) {
							arr.push(item.key);
						}
					});
				}
				// this.form.person[this.selectGroup] = arr;
				// this.selectedPeople = arr;
				// this.form.person[this.selectGroup];
			},
			selectgroup(it, index) {
				this.getPeople(it.zuzhi_xuhao, index);
			},
			handlePictureCardPreview(file) {
				this.dialogVisible = true;
				this.dialogImageUrl = file.url;
			},
			upload(val, type) {
				let client = new OSS(this.$bus.config.ossConfig);
				let file = val.file;
				let _this = this;
				let id = this.$bus.config.plan + "/t" + Date.now() + "s" + file.size + "/" + file.name;
				this.$set(this.fileList, id, {
					name: file.name,
					size: file.size,
					uploading: true,
					time: 0,
					progress: 0,
					key: id,
					client: client,
				});
				// _this.getTimes(file, id)

				// 定义上传方法。
				function multipartUpload() {
					_this.fileList[id].client
						.multipartUpload(id, file, {
							checkpoint: _this.fileList[id] ? _this.fileList[id].data : null,
							progress: (p, checkpoint, res) => {
								//log(p,checkpoint,res)
								if (checkpoint) {
									_this.fileList[id].progress = p * 100;
									_this.fileList[id].data = checkpoint;
								}
							},
							partSize: 1000 * 1024, //设置分片大小
							timeout: 120000, //设置超时时间
							mime: val.type,
						})
						.then((res) => {
							_this.fileList[id].progress = 100;
							_this.fileList[id].uploading = false;
							// _this.$notify({
							//   title: "上传成功",
							//   message: `${_this.fileList[id].name}上传完成`,
							//   type: "success",
							// });
							// _this.form.image_name = `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`

							if (!type) {
								_this.fileList.push({
									name: _this.fileList[id].name,
									url: `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`,
								});
								_this.nowImage.push(`http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`);
							} else {
								_this.fileList1.push({
									name: _this.fileList[id].name,
									url: `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`,
								});
								_this.nowImage1.push(`http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`);
							}

							// var stobj = {tr_task_id:_this.uuid,tr_baogao_address,tr_sub_status:1,tr_shengcheng_status:1,tr_baogao_xingshi:0}
							// _this.$post('/api-b/tr/plan/baogaoaddress',stobj).then(data=>{

							//     _this.getList()
							// })
						})
						.catch((err) => {
							if (err.code == "RequestError" || err.code == "ConnectionTimeoutError") {
								//网络错误或超时
								setTimeout(multipartUpload, 3000);
							}
						});
				}

				multipartUpload();
			},
			handleRemove(file, type) {
				var fileList = [];

				var nowImage = [];
				if (type == "nowImage") {
					fileList = this.fileList;
					nowImage = this.nowImage;
				} else {
					fileList = this.fileList1;
					nowImage = this.nowImage1;
				}
				fileList.map((item, index) => {
					if (item.uid == file.uid) {
						fileList.splice(index, 1);
						nowImage.splice(nowImage.indexOf(item.url), 1);
					}
				});
			},
			// handleRemove1(file,type) {
			//   console.log(type)
			//   return
			//   this.fileList.map((item, index) => {
			//     if (item.uid == file.uid) {
			//       this.fileList.splice(index, 1);
			//       this.nowImage1.splice(this.nowImage.indexOf(item.url), 1);
			//     }
			//   });
			// },
			save() {
				const loading = this.$loading({
        lock: true,
        text: "上传中，请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
				var url = this.$route.query.id ? "/drill/drillupdate" : "/drill/drillinsert";

				// for(var i in this.form){
				//   if(this.form[i]==null){
				//     this.form[i]=''
				//   }
				// }
				this.$post(url, this.form)
					.then((res) => {
						loading.close()
						this.$message({message: res.msg,type: "success", duration: 700,});
						this.$router.back();
						// this.reload()
						this.btnLoading = false;
					})
					.catch((err) => {
						this.btnLoading = false;
					});
			},
			saveExport() {
				const loading = this.$loading({
        lock: true,
        text: "上传中，请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
				this.$post("/drill/syncWord", this.form)
					.then((res) => {
						loading.close()
						this.$message({message: res.msg,type: "success", duration: 700,});
						this.reload();
						this.btnLoading = false;
					})
					.catch((err) => {
						this.btnLoading = false;
					});
			},
			onSubmit(exprot) {
				this.$refs.form.validate((valid) => {
					if (valid) {
						this.btnLoading = true;
						this.form.miehuo_image = this.nowImage.join(",");
						this.form.drill_image = this.nowImage1.join(",");
						this.form.drill_status = this.$route.query.page == 3 ? "2" : this.$route.query.page == 0 ? "0" : "1";
						// this.form.get_item = this.CheckedKeys;
						if (exprot == 1) {
							this.saveExport();
						} else {
							this.save();
						}
					} else {
						this.$message.warning("请输出必填项");
					}
				});

				//    this.$refs.form.validate((valid) => {
				//   if (valid) {
				//     this.save();
				//   } else {
				//     this.nowIndex = 0;
				//     return false;
				//   }
				// });

				// this.$refs.form.validate((valid) => {
				//               if (valid) {
				//               } else {
				//                   console.log('error submit!!');
				//                   return false;
				//               }
				//           });
			},

			addtime() {
				if (this.form.get_rate.length < 2) {
					this.form.get_rate.push({
						m_start_time: "",
						m_end_time: "",
						m_rate: "",
					});
				} else {
					this.form.get_rate.splice(1);
				}
			},
			getList() {},
			//树的数组
		},
	};
</script>

<style scoped lang="scss">
	::v-deep .el-upload--picture-card {
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		width: 148px !important;
		/* height: 148px; */
		/* cursor: pointer; */
		line-height: 146px;
		vertical-align: top;
	}
	.container-list {
		padding: 0 20px;
	}
	.tree {
		font-size: 18px;
	}
	.duty p {
		margin-top: 10px;
	}
	.perbutton {
		width: 120px;
	}
</style>
